import React from "react";
import { Container, Row, Col, Card } from "reactstrap";
import "../styles/Download.css";

const Download = () => {
  return (
    <React.Fragment>
      <Container>
        <h2 className="download-app">Download the Orion Stars App</h2>
      </Container>

      <Container>
        <Row className="g-4">
          <Col xs={12} sm={12} md={6} lg={6}>
            <Card className="h-100 download-card-override">
              <div className="download-img-wrapper">
                <img
                  alt="google-play"
                  className=""
                  loading="lazy"
                  src="../assets/google-play.svg"
                />
                <img
                  alt="google-play"
                  className="qr-image"
                  loading="lazy"
                  src="../assets/orion-QR.png"
                  width={260}
                  height={260}
                />
              </div>
              <div className="download-for">Download for Android</div>
              <ol className="click-on-the-container">
                <li>
                  Scan the QR code and click ‘Download’ to download Orion Stars
                </li>
                <li>Approve the download</li>
                <li>Approve the file size download </li>
                <li>Allow installation from unknown source (if required)</li>
                <li>Open the downloaded file from the browser</li>
                <li>Click “Install”</li>
                <li>Launch the app</li>
                <li>Allow or deny permissions </li>
                <li>Login</li>
                <li>Start playing</li>
              </ol>
            </Card>
          </Col>

          <Col xs={12} sm={12} md={6} lg={6}>
            <Card className="h-100 download-card-override">
              <div className="download-img-wrapper">
                <img
                  alt="app-store"
                  className=""
                  loading="lazy"
                  src="../assets/app-store.svg"
                />
                <img
                  alt="google-play"
                  className="qr-image"
                  loading="lazy"
                  src="../assets/orion-QR.png"
                  width={260}
                  height={260}
                />
              </div>
              <div className="download-for">Download for iOS</div>
              <ol className="click-on-the-container">
                <li>Scan the QR code and press ‘Download’</li>
                <li>Follow the on-screen instructions to install</li>
                <li>Enter the download code</li>
                <li>Start playing </li>
              </ol>
            </Card>
          </Col>

          <Col xs={12} sm={12} md={6} lg={6}>
            <Card className="h-100 download-card-override">
              <div className="download-img-wrapper">
                <img
                  alt="google-play"
                  className="qr-image"
                  loading="lazy"
                  src="../assets/windows-logo.svg"
                />
              </div>
              <div className="download-for">Download for Windows</div>
              <ol className="click-on-the-container">
                <li>Launch your browser and download Bluestacks</li>
                <li>
                  Once the download is complete, open the file and click
                  ‘Install Now’
                </li>
                <li>Allow any requested changes </li>
                <li>
                  Sign into Google Play or skip by selecting “I’ll do it later”
                </li>
                <li>Visit this link and click ‘Download’</li>
                <li>Open the downloaded file</li>
                <li>
                  Click the Orion Stars app icon on your screen and start
                  playing
                </li>
              </ol>
            </Card>
          </Col>

          <Col xs={12} sm={12} md={6} lg={6}>
            <Card className="h-100 download-card-override">
              <div className="download-for">Minimum Requirements</div>
              <ul className="click-on-the-container">
                <li>OS: Microsoft Windows 7 or newer.</li>
                <li>Processor: Intel or AMD.</li>
                <li>
                  RAM: At least 2GB of RAM (Note: Disk space is not a substitute
                  for RAM).
                </li>
                <li>HDD: 5GB of free disk space.</li>
                <li>
                  Permissions: You must have Administrator rights on your PC.
                </li>
                <li>
                  Graphics: Up-to-date graphics drivers from Microsoft or your
                  chipset vendor.
                </li>
              </ul>

              <div className="download-for">Minimum Requirements</div>
              <ul className="click-on-the-container">
                <li>OS: Microsoft Windows 10</li>
                <li>{`Processor: Intel or AMD Multi-Core Processor with a Single Thread PassMark score > 1000 and virtualization extensions enabled in the BIOS (See help). [Check your processor's Single Thread PassMark score here.](Insert link)`}</li>
                <li>
                  Graphics: Intel/Nvidia/ATI, Onboard or Discrete controller
                  with a PassMark score ≥ 750. [Check your graphics controller's
                  PassMark score here.](Insert link)
                </li>
                <li>RAM: 8GB or higher</li>
                <li>Storage: SSD (or Fusion/Hybrid Drives)</li>
                <li>
                  Internet: Broadband connection for accessing games, accounts,
                  and related content.
                </li>
                <li>
                  Graphics Drivers: Ensure your graphics drivers are up-to-date
                  from Microsoft or the chipset vendor.
                </li>
              </ul>
            </Card>
          </Col>

        </Row>
      </Container>
      {/* </div> */}
    </React.Fragment>
  );
};

export default Download;
